import React, { useEffect, useState } from "react";
import { CALL_CRM, TASK_CRM } from "../../../utils/constants/assets";
import { STRINGS } from "../strings";
import classes from "./Crm.module.css";
import CreateTaskCrmPopUp from "./components/CreateTaskCrmPopUp";
import ContactDetailEmptyScreen from "./components/AccountDetailEmptyScreen";
import { useLocation } from "react-router-dom";
import ListingTaskCard from "./components/ListingTaskCard";
import TypographyInline from "../../../components/Typography/TypographyInline";
import { fontWeight } from "../../../utils/constants/UI";
import { BRAND } from "../../../utils/constants/colors";
import { Button } from "../../../components/Buttons";
import SkeletonLoaderCRMScreens from "./components/SkeletonLoaderCRMScreens";
import { decompressString } from "../../../utils/helpers";

// Campaign-driven tasks store the task description in `body` (with
// `from_campaign === true`), while manual user tasks store it in `notes`.
// `is_compressed` can be set on either. ListingTaskCard renders `notes`,
// so we surface whichever field has content (preferring `notes`) and
// decompress when needed. Existing manual-task behaviour is preserved.
const safeDecompress = (val) => {
  if (val == null) return val;
  try {
    return decodeURIComponent(decompressString(val));
  } catch (e) {
    try {
      return decompressString(val);
    } catch (e2) {
      return val;
    }
  }
};

const escapeHtml = (s) =>
  String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const formatPlainTextToHtml = (input) => {
  if (typeof input !== "string") return input;
  if (/<[a-zA-Z][^>]*>/.test(input)) return input;
  const text = input.replace(/\r\n/g, "\n").trim();
  if (!text) return "";
  const blocks = text.split(/\n{2,}/);
  const renderBlock = (block) => {
    const lines = block.split("\n").map((l) => l.trim()).filter(Boolean);
    if (!lines.length) return "";
    const isBullet = (l) => /^[•\-*]\s+/.test(l);
    if (lines.every(isBullet)) {
      return `<ul>${lines
        .map((l) => `<li>${escapeHtml(l.replace(/^[•\-*]\s+/, ""))}</li>`)
        .join("")}</ul>`;
    }
    const parts = [];
    let bullets = [];
    const flush = () => {
      if (bullets.length) {
        parts.push(
          `<ul>${bullets.map((b) => `<li>${escapeHtml(b)}</li>`).join("")}</ul>`,
        );
        bullets = [];
      }
    };
    lines.forEach((l) => {
      if (isBullet(l)) {
        bullets.push(l.replace(/^[•\-*]\s+/, ""));
        return;
      }
      flush();
      const m = l.match(/^([A-Z][A-Za-z ]{1,40}):\s*(.*)$/);
      if (m) {
        parts.push(
          m[2]
            ? `<p><strong>${escapeHtml(m[1])}:</strong> ${escapeHtml(m[2])}</p>`
            : `<p><strong>${escapeHtml(m[1])}:</strong></p>`,
        );
      } else {
        parts.push(`<p>${escapeHtml(l)}</p>`);
      }
    });
    flush();
    return parts.join("");
  };
  return blocks.map(renderBlock).join("");
};

const resolveTaskContent = (logData) => {
  if (!logData) return logData;
  const hasNotes =
    typeof logData.notes === "string" && logData.notes.trim().length > 0;
  const hasBody =
    typeof logData.body === "string" && logData.body.trim().length > 0;
  if (!hasNotes && !hasBody) return logData;
  const sourceField = hasNotes ? "notes" : "body";
  const raw = logData[sourceField];
  const decoded = logData.is_compressed ? safeDecompress(raw) : raw;
  return { ...logData, notes: formatPlainTextToHtml(decoded) };
};

const AccounttDetailTaskScreen = ({
  contactDetails,
  contactId,
  totalTasks = 0,
  taskListData = [],
  screenLoading = false,
  getTaskLogList = () => {},
  setTaskListData = () => {},
}) => {
  const location = useLocation();
  const [createFlag, setCreateFlag] = useState(false);
  const [type, setType] = useState("");
  const [pageCount, setPageCount] = useState(0);

  const locationTabs = location?.search?.split("?tabs=");
  const UpdatedLocation = locationTabs[1] == STRINGS.CALLS_SMALL;

  const emptyScreenButtons = [
    {
      id: UpdatedLocation ? STRINGS.CALLS_SMALL : STRINGS.TASKS_SMALL,
      label: UpdatedLocation ? STRINGS.CREATE_CALL : STRINGS.CREATE_TODO,
      variant: "primary",
      disabled: !Object.keys(contactDetails).length,
      onClick: () => {
        setCreateFlag(true);
      },
    },
  ];

  //Click for open (create Task pop up)
  const createTaskOpenHandler = () => {
    setCreateFlag(true);
  };

  const onScrollApiHandler = () => {
    const scrollableDiv = document?.getElementsByClassName(
      STRINGS.ALL_TASK_LIST
    )[0];
    const isAtBottom =
      scrollableDiv?.scrollTop >=
      scrollableDiv?.scrollHeight - scrollableDiv?.clientHeight;
    if (isAtBottom && totalTasks > taskListData?.length) {
      setPageCount(pageCount + 1);
      getTaskLogList(true, pageCount + 1);
    }
  };

  useEffect(() => {
    getTaskLogList();
  }, [contactDetails]);

  return (
    <div
      className={`${classes.taskScreenMainContainer} ${STRINGS.ALL_TASK_LIST}`}
      id="comments_body"
      onScroll={onScrollApiHandler}
    >
      {screenLoading ? (
        <SkeletonLoaderCRMScreens accordionLengths={5} buttonsLength={1} />
      ) : (
        <>
          {/* Checking the length of the Task list */}
          {taskListData?.length ? (
            <div className={classes.taskListContainer}>
              <div className={classes.HeadTaskContainerSubHead}>
                <TypographyInline
                  label={
                    UpdatedLocation ? STRINGS.ALL_CALLS : STRINGS.ALL_TODOS
                  }
                  size={"md"}
                  fontWeight={fontWeight.SEMIBOLD}
                  color={BRAND.SECONDARY}
                />
                <div className={classes.WIdthButton}>
                  <Button
                    label={
                      UpdatedLocation
                        ? STRINGS.CREATE_CALL
                        : STRINGS.CREATE_TODO
                    }
                    variant={"primary"}
                    size={"sm36"}
                    onClick={() => {
                      createTaskOpenHandler();
                      UpdatedLocation
                        ? setType(STRINGS.CALL)
                        : setType(STRINGS.TASKS);
                    }}
                  />
                </div>
              </div>
              {/* Sending Task list to the ListingTaskCard*/}

              {taskListData?.map((logData, index) => {
                return (
                  <div key={`log${index}`}>
                    <ListingTaskCard
                      id={`log${index}`}
                      logData={resolveTaskContent(logData)}
                      contactDetails={taskListData}
                      contact_id={contactId}
                      setTaskListData={setTaskListData}
                      expanded={!index}
                      type={UpdatedLocation ? "call" : "tasks"}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <div className={classes.TaskHead}>
              <ContactDetailEmptyScreen
                src={UpdatedLocation ? CALL_CRM : TASK_CRM}
                label={
                  UpdatedLocation ? STRINGS.TASK_LABEL1 : STRINGS.TASK_LABEL
                }
                buttonItems={emptyScreenButtons}
              />
            </div>
          )}
        </>
      )}
      {createFlag && (
        <CreateTaskCrmPopUp
          type={UpdatedLocation ? STRINGS.CALL : STRINGS.TASKS_SMALL}
          getTasks={getTaskLogList}
          open={createFlag}
          close={setCreateFlag}
          contact_id={contactId}
          setTaskListData={setTaskListData}
        />
      )}
    </div>
  );
};

export default AccounttDetailTaskScreen;
